(function () {
  'use strict';

  function esc(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function findMatches(query) {
    var arts = window.blogArticles;
    if (!arts || !arts.length) return [];
    var terms = query.toLowerCase().split(/\s+/).filter(function(t){ return t.length > 1; });
    if (!terms.length) return [];
    return arts.filter(function(a){
      var txt = ((a.t||'')+' '+(a.e||'')).toLowerCase();
      return terms.some(function(term){ return txt.indexOf(term) !== -1; });
    }).slice(0, 3);
  }

  function injectArticles(query) {
    var list = document.getElementById('predictive-search-results-list');
    if (!list) return;
    var old = list.querySelectorAll('.bsearch-art');
    for (var i = 0; i < old.length; i++) { old[i].parentNode.removeChild(old[i]); }
    var matches = findMatches(query);
    if (!matches.length) return;
    var anchor = list.querySelector('.predictive-search__item--term');
    var before = anchor ? anchor.parentNode : null;
    for (var j = matches.length - 1; j >= 0; j--) {
      var a = matches[j];
      var li = document.createElement('li');
      li.className = 'predictive-search__list-item bsearch-art';
      li.setAttribute('role','option');
      li.setAttribute('aria-selected','false');
      li.innerHTML =
        '<a href="'+esc(a.u)+'" class="predictive-search__item predictive-search__item--link link--text" tabindex="-1">'+
        '<div class="predictive-search__item-content">'+
        '<span style="font-size:10px;text-transform:uppercase;letter-spacing:.5px;color:#999;display:block;margin-bottom:2px">Blog</span>'+
        '<h3 class="predictive-search__item-heading product-card__name">'+esc(a.t)+'</h3>'+
        '</div></a>';
      if (before) { list.insertBefore(li, before); } else { list.appendChild(li); }
    }
  }

  function hookIntoSearch() {
    var ps = document.querySelector('predictive-search');
    if (!ps) return;
    var input = ps.querySelector('input[type="search"]');
    if (!input) return;

    customElements.whenDefined('predictive-search').then(function() {
      var proto = Object.getPrototypeOf(ps);
      var originalRender = proto.renderSearchResults;
      if (!originalRender) return;
      ps.renderSearchResults = function(markup) {
        originalRender.call(this, markup);
        var q = input.value.trim();
        if (q.length >= 2) { injectArticles(q); }
      };
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hookIntoSearch);
  } else {
    hookIntoSearch();
  }
}());
